module.exports = __webpack_public_path__ + "7d088296/img/arrow-share-icon.00a12c29.svg";